export default "__VITE_ASSET__0soy4KMX__"